<template>
  <div id="app">
    <OnboardingPage />
  </div>
</template>

<script>
import OnboardingPage from './OnboardingPage.vue';

export default {
  name: 'App',
  components: {
    OnboardingPage
  }
};
</script>

<style>
#app {
  margin: 0;
  font-family: Montserrat, sans-serif;
  text-align: center;
  color: #2c3e50;
}
</style>
